/* global window, document, maplibregl, fetch */
(function (window, document) {
    var root = document.getElementById('vg-osservatorio-root');
    if (!root) return;
    if (root._vgOsservatorioBooted) return;
    root._vgOsservatorioBooted = true;

    function qs(sel, el) {
        return (el || document).querySelector(sel);
    }

    function apiBase() {
        var base = (root.getAttribute('data-api-base') || '').trim();
        if (!base) base = '/api';
        return String(base).replace(/\/+$/, '');
    }

    function isMemberFromDom() {
        try {
            return String(root.getAttribute('data-is-member') || '').trim() === '1';
        } catch (e) {
            return false;
        }
    }

    function fetchGhostSessionToken() {
        return fetch('/members/api/session/', { method: 'GET', credentials: 'include' })
            .then(function (r) {
                if (r.status === 204) return null;
                if (!r.ok) return r.text().then(function (t) { throw new Error('Ghost session HTTP ' + r.status + (t ? ' ' + t.slice(0, 120) : '')); });
                return r.text();
            })
            .then(function (token) {
                token = (token || '').trim();
                return token || null;
            });
    }

    function gatewaySessionLogin(sessionToken) {
        return fetch(apiBase() + '/auth/ghost/session/login', {
            method: 'POST',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ session_token: sessionToken })
        }).then(function (r) {
            return r.json().then(function (data) {
                if (!r.ok) {
                    var d = (data && data.detail) ? String(data.detail) : '';
                    throw new Error(d || ('Gateway login HTTP ' + r.status));
                }
                return data;
            });
        });
    }

    function setStatus(msg) {
        var el = qs('[data-osservatorio-status]', root);
        if (el) el.textContent = msg || '';
    }

    function fmtEuro(n) {
        var x = typeof n === 'number' ? n : parseFloat(String(n || '0'));
        if (!isFinite(x)) x = 0;
        try {
            return x.toLocaleString('it-IT', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 });
        } catch (e) {
            return '€ ' + Math.round(x);
        }
    }

    function fmtInt(n) {
        var x = typeof n === 'number' ? n : parseInt(String(n || '0'), 10);
        if (!isFinite(x)) x = 0;
        try {
            return x.toLocaleString('it-IT');
        } catch (e) {
            return String(x);
        }
    }

    function vgTrackOsservatorio(event, payload) {
        try {
            var paq = window._paq = window._paq || [];
            paq.push(['trackEvent', 'Osservatorio', String(event || 'event'), JSON.stringify(payload || {})]);
        } catch (e) {}
    }

    function setMetaTag(name, content) {
        if (!content) return;
        var sel = name === 'title' ? null : 'meta[name="' + name + '"]';
        if (name === 'title') {
            document.title = content;
            return;
        }
        var el = document.querySelector(sel);
        if (!el) {
            el = document.createElement('meta');
            el.setAttribute('name', name);
            document.head.appendChild(el);
        }
        el.setAttribute('content', content);
    }

    function setCanonical(url) {
        if (!url) return;
        var el = document.querySelector('link[rel="canonical"]');
        if (!el) {
            el = document.createElement('link');
            el.setAttribute('rel', 'canonical');
            document.head.appendChild(el);
        }
        el.setAttribute('href', url);
    }

    function injectJsonLd(obj) {
        if (!obj) return;
        var id = 'vg-oss-jsonld';
        var el = document.getElementById(id);
        if (!el) {
            el = document.createElement('script');
            el.type = 'application/ld+json';
            el.id = id;
            document.head.appendChild(el);
        }
        try { el.textContent = JSON.stringify(obj); } catch (e2) {}
    }

    function renderFaqList(faq) {
        var wrap = document.querySelector('[data-oss-faq]');
        var list = document.querySelector('[data-oss-faq-list]');
        if (!wrap || !list) return;
        if (!faq || !faq.length) {
            var hasStatic = list.querySelector('.vg-oss-faq__q');
            wrap.hidden = !hasStatic;
            return;
        }
        var html = '';
        for (var i = 0; i < faq.length; i++) {
            var f = faq[i] || {};
            var q = String(f.q || '').trim();
            var a = String(f.a || '').trim();
            if (!q || !a) continue;
            html += '<div class="vg-oss-faq__item">' +
                '<h3 class="vg-oss-faq__q">' + esc(q) + '</h3>' +
                '<p class="vg-oss-faq__a">' + esc(a) + '</p>' +
                '</div>';
        }
        if (!html) {
            wrap.hidden = true;
            return;
        }
        list.innerHTML = html;
        wrap.hidden = false;
    }

    function renderProvinceLinks(links) {
        var wrap = document.querySelector('[data-oss-province-links]');
        var tb = document.querySelector('[data-oss-province-body]');
        if (!wrap || !tb) return;
        if (!links || !links.length) {
            wrap.hidden = true;
            tb.innerHTML = '';
            return;
        }
        renderRankingTable('[data-oss-province-body]', links, { amount: true });
    }

    function showSeoBlocksIfAny() {
        var parent = document.querySelector('[data-oss-seo-blocks]');
        if (!parent) return;
        var any = parent.querySelector('[data-oss-top-regioni]:not([hidden]), [data-oss-top-cpv]:not([hidden]), [data-oss-recent]:not([hidden])');
        parent.hidden = !any;
    }

    function renderRankingTable(tbodySel, rows, opts) {
        var tb = document.querySelector(tbodySel);
        var section = tb && tb.closest('[data-oss-top-regioni], [data-oss-top-cpv], [data-oss-province-links]');
        if (!tb || !rows || !rows.length) return;
        opts = opts || {};
        var html = '';
        for (var i = 0; i < rows.length; i++) {
            var r = rows[i] || {};
            var label = String(r.label || '').trim();
            if (!label) {
                var pref = String(r.cpv_prefix || '').trim();
                var lab = String(r.cpv_label || '').trim();
                if (pref && lab && lab !== pref) label = pref + ' — ' + lab;
                else label = pref || lab;
            }
            label = esc(label);
            var n = fmtInt(r.numero_bandi || 0);
            var cell = r.url ? '<a href="' + esc(r.url) + '">' + label + '</a>' : label;
            html += '<tr><td>' + cell + '</td><td>' + n + '</td>';
            if (opts.amount) html += '<td>' + esc(fmtEuro(r.importo_totale || 0)) + '</td>';
            html += '</tr>';
        }
        tb.innerHTML = html;
        if (section) section.hidden = false;
        showSeoBlocksIfAny();
    }

    function renderRecentTenders(items) {
        var wrap = document.querySelector('[data-oss-recent]');
        var list = document.querySelector('[data-oss-recent-list]');
        if (!wrap || !list || !items || !items.length) return;
        var html = '';
        for (var i = 0; i < items.length; i++) {
            var t = items[i] || {};
            html += '<li><a href="' + esc(t.url || '#') + '">' + esc(t.title || 'Bando') + '</a>';
            if (t.buyer) html += ' <span class="vg-oss-recent__meta">— ' + esc(t.buyer) + '</span>';
            html += '</li>';
        }
        list.innerHTML = html;
        wrap.hidden = false;
        showSeoBlocksIfAny();
    }

    function renderUpdatedAt(iso) {
        var wrap = document.querySelector('[data-oss-updated-at]');
        var t = document.querySelector('[data-oss-updated-time]');
        if (!wrap || !t || !iso) return;
        t.textContent = String(iso).slice(0, 10);
        t.setAttribute('datetime', String(iso).slice(0, 10));
        wrap.hidden = false;
    }

    function renderCtaFromMember() {
        var paid = String(root.getAttribute('data-is-paid') || '').trim() === '1';
        var member = isMemberFromDom();
        var titleEl = document.querySelector('[data-oss-cta-title]');
        var bodyEl = document.querySelector('[data-oss-cta-body]');
        var pri = document.querySelector('[data-oss-cta-primary]');
        var sec = document.querySelector('[data-oss-cta-secondary]');
        if (!titleEl || !bodyEl || !pri || !sec) return;
        if (paid) {
            titleEl.textContent = 'Apri in VistaGare Radar';
            bodyEl.textContent = 'Analizza buyer, trend e affidabilità con gli strumenti Radar.';
            pri.textContent = 'Apri Radar';
            pri.setAttribute('href', '/vistagare-radar/');
            sec.textContent = 'Notifiche';
            sec.setAttribute('href', '/connect-telegram/');
        } else if (member) {
            titleEl.textContent = 'Scarica i dati e passa a Radar';
            bodyEl.textContent = 'Esporta dataset regionali per CPV. Radar Pro aggiunge analisi operative.';
            pri.textContent = 'Scopri Radar';
            pri.setAttribute('href', '/vistagare-radar/');
            sec.textContent = 'Account';
            sec.setAttribute('href', '#/portal/account');
        } else {
            titleEl.textContent = 'Iscriviti gratis per scaricare i dati';
            bodyEl.textContent = 'L’iscrizione gratuita sblocca export regionali e protegge il servizio da abusi.';
            pri.textContent = 'Iscriviti';
            pri.setAttribute('href', '#/portal/signup');
            pri.setAttribute('data-portal', 'signup');
            pri.className = 'gh-head-button';
            sec.textContent = 'Accedi';
            sec.setAttribute('href', '#/portal/signin');
            sec.setAttribute('data-portal', 'signin');
            sec.className = 'gh-head-link';
        }
    }

    async function loadWeeklyStat() {
        try {
            if (currentSlugFromPath() !== 'italia') return;
            var data = await apiJson('/osservatorio/weekly-stat');
            var wrap = document.querySelector('[data-oss-weekly]');
            var txt = document.querySelector('[data-oss-weekly-text]');
            if (!wrap || !txt) return;
            var parts = [];
            var year = '';
            var pl = String(data.period_label || '');
            var ym = pl.match(/year:(\d{4})/);
            if (ym) year = ym[1];
            if (data.regione_top && data.regione_top.label) {
                parts.push('Regione con più bandi' + (year ? (' nel ' + year) : '') + ': ' + data.regione_top.label);
            }
            if (data.cpv_top) {
                var cpvTxt = String(data.cpv_top.label || data.cpv_top.cpv_label || '').trim();
                if (!cpvTxt && data.cpv_top.cpv_prefix) cpvTxt = String(data.cpv_top.cpv_prefix);
                if (cpvTxt) parts.push('CPV più frequente' + (year ? (' nel ' + year) : '') + ': ' + cpvTxt);
            }
            if (!parts.length) return;
            txt.textContent = 'Panoramica nazionale — ' + parts.join(' · ');
            wrap.hidden = false;
        } catch (e) {}
    }

    async function loadNationalSummary() {
        var y = readYearParam();
        var path = '/osservatorio/summary' + (y ? ('?year=' + encodeURIComponent(y)) : '');
        var data = await apiJson(path);
        var meta = data.meta || {};
        if (meta.title) setMetaTag('title', meta.title);
        if (meta.description) setMetaTag('description', meta.description);
        if (meta.canonical || meta.canonical_url) setCanonical(meta.canonical || meta.canonical_url);
        if (meta.h1) {
            var h1 = document.querySelector('[data-oss-h1]');
            if (h1) h1.textContent = meta.h1;
        }
        renderUpdatedAt(meta.last_data_update || data.last_data_update);
        var rankings = data.rankings || {};
        renderRankingTable('[data-oss-top-regioni-body]', rankings.top_regioni_bandi || [], { amount: true });
        renderRankingTable('[data-oss-top-cpv-body]', rankings.top_cpv || [], { amount: false });
        renderRecentTenders(data.recent_tenders || []);
        renderFaqList(data.faq || []);
        if (data.json_ld) injectJsonLd(data.json_ld);
        vgTrackOsservatorio('summary_load', { scope: 'italia' });
        return data;
    }

    function applyViewSeo(data) {
        var meta = data.meta || {};
        if (meta.title) setMetaTag('title', meta.title);
        if (meta.description) setMetaTag('description', meta.description);
        if (meta.canonical || meta.canonical_url) setCanonical(meta.canonical || meta.canonical_url);
        if (meta.h1) {
            var h1 = document.querySelector('[data-oss-h1]');
            if (h1) h1.textContent = meta.h1;
        }
        renderUpdatedAt(meta.last_data_update || data.last_data_update);
        renderFaqList(data.faq || []);
        if (data.json_ld) injectJsonLd(data.json_ld);
        var bc = document.querySelector('[data-oss-breadcrumb-current]');
        if (bc && data.view && data.view.label && data.view.slug !== 'italia') {
            var span = bc.querySelector('span');
            if (span) span.textContent = data.view.label;
            bc.hidden = false;
        }
        vgTrackOsservatorio('view_load', { slug: (data.view && data.view.slug) || '' });
    }

    function showLeadMagnet() {
        var el = document.querySelector('[data-oss-lead]');
        if (el) el.hidden = false;
        vgTrackOsservatorio('download_lead', {});
    }

    async function saveCurrentSearch() {
        if (!isMemberFromDom()) {
            openDialog();
            return;
        }
        await ensureGatewaySession();
        var slug = String(_currentViewSlug || 'italia');
        var cpv = '';
        try { cpv = String(cpvSelect.value || '').trim(); } catch (e) { cpv = ''; }
        var y = readYearParam();
        await fetch(apiBase() + '/osservatorio/saved-searches', {
            method: 'POST',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
                label: 'Osservatorio ' + slug + (cpv ? (' CPV ' + cpv) : ''),
                view_slug: slug,
                cpv_prefix: cpv || null,
                year: y ? parseInt(y, 10) : null
            })
        });
        setStatus('Ricerca salvata.');
        vgTrackOsservatorio('save_search', { slug: slug, cpv: cpv });
    }

    function currentSlugFromPath() {
        if (currentGeoFromPath()) return 'italia';
        var init = String(root.getAttribute('data-initial-region') || '').trim();
        if (init) return init;
        var p = String(window.location.pathname || '/').replace(/\/+$/, '');
        if (p === '/osservatorio') return 'italia';
        // /osservatorio/regione/<slug>
        var m = p.match(/^\/osservatorio\/regione\/([^/]+)$/);
        if (m) return decodeURIComponent(m[1]);
        return 'italia';
    }

    function isGeoPage() {
        return !!currentGeoFromPath();
    }

    function currentGeoFromPath() {
        var p = String(window.location.pathname || '');
        var m = p.match(/^\/osservatorio\/(provincia|comune)\/([^/]+)\/?$/);
        if (m) return { kind: m[1], slug: decodeURIComponent(m[2]) };
        var kind = String(root.getAttribute('data-geo-page') || '').trim();
        var slug = String(root.getAttribute('data-geo-slug') || '').trim();
        if (kind && slug) return { kind: kind, slug: slug };
        return null;
    }

    function readInitialGeoPayload() {
        var el = document.getElementById('vg-oss-initial-geo');
        if (!el || !el.textContent) return null;
        try {
            return JSON.parse(el.textContent);
        } catch (e) {
            return null;
        }
    }

    function currentGeoFromDom() {
        return currentGeoFromPath();
    }

    function pushSlug(slug) {
        if (slug === 'italia') {
            window.location.href = '/osservatorio/';
            return;
        }
        window.location.href = '/osservatorio/regione/' + encodeURIComponent(slug) + '/';
    }

    async function apiJson(path) {
        var r = await fetch(apiBase() + path, { credentials: 'include', headers: { Accept: 'application/json' } });
        var j = await r.json().catch(function () { return {}; });
        if (!r.ok) {
            var msg = (j && j.detail) ? String(j.detail) : ('HTTP ' + r.status);
            throw new Error(msg);
        }
        return j;
    }

    async function loadTerritoryIcons() {
        if (_territoryIcons) return _territoryIcons;
        try {
            _territoryIcons = await apiJson('/osservatorio/icons');
        } catch (e) {
            _territoryIcons = { italia: '', regions: {} };
        }
        return _territoryIcons;
    }

    var viewSelect = qs('[data-oss-view]', root);
    var cpvSelect = qs('[data-oss-cpv]', root);
    var backLink = qs('[data-oss-back]', root);
    var periodEl = qs('[data-oss-period]', root);
    var exportWrap = qs('[data-oss-export]', root);
    var exportToggle = qs('[data-oss-export-toggle]', root);
    var exportMenu = qs('[data-oss-export-menu]', root);
    var dialog = qs('[data-oss-dialog]', root);
    var dialogBackdrop = qs('[data-oss-dialog-backdrop]', root);
    var dialogClose = qs('[data-oss-dialog-close]', root);
    var _yearParam = null;
    var _cpvParam = null;
    var _gatewaySessionOk = false;

    function readYearParam() {
        if (_yearParam != null) return _yearParam;
        try {
            var q = new URLSearchParams(window.location.search || '');
            var y = String(q.get('year') || '').trim();
            if (y && /^[0-9]{4}$/.test(y)) {
                _yearParam = y;
                return _yearParam;
            }
        } catch (e) {}
        // Default: last completed year
        try {
            _yearParam = String((new Date()).getFullYear() - 1);
        } catch (e2) {
            _yearParam = '';
        }
        return _yearParam;
    }

    function readCpvParam() {
        if (_cpvParam != null) return _cpvParam;
        try {
            var q = new URLSearchParams(window.location.search || '');
            _cpvParam = String(q.get('cpv') || '').trim();
        } catch (e) {
            _cpvParam = '';
        }
        return _cpvParam;
    }

    function openDialog() {
        if (!dialog) return;
        dialog.hidden = false;
        dialog.setAttribute('aria-hidden', 'false');
        try { if (dialogBackdrop) dialogBackdrop.focus(); } catch (e) {}
    }

    function closeDialog() {
        if (!dialog) return;
        dialog.hidden = true;
        dialog.setAttribute('aria-hidden', 'true');
    }

    function closeExportMenu() {
        if (!exportMenu || !exportToggle) return;
        exportMenu.hidden = true;
        exportToggle.setAttribute('aria-expanded', 'false');
    }

    function openExportMenu() {
        if (!exportMenu || !exportToggle) return;
        exportMenu.hidden = false;
        exportToggle.setAttribute('aria-expanded', 'true');
    }

    function exportPrereqsOk() {
        var slug = String(_currentViewSlug || '').trim();
        var y = String(readYearParam() || '').trim();
        var cpv = '';
        try { cpv = String(cpvSelect.value || '').trim(); } catch (e) { cpv = ''; }
        return !!(slug && slug !== 'italia' && y && /^[0-9]{4}$/.test(y) && cpv);
    }

    function renderExportState() {
        if (!exportWrap || !exportToggle) return;
        var ok = exportPrereqsOk();
        exportWrap.hidden = false;
        exportToggle.disabled = !ok;
        exportToggle.title = ok ? 'Scarica dataset' : 'Seleziona una regione, un CPV e un anno per scaricare';
        if (!ok) closeExportMenu();
    }

    function ensureGatewaySession() {
        if (_gatewaySessionOk) return Promise.resolve();
        return fetchGhostSessionToken()
            .then(function (token) {
                if (!token) throw new Error('Accedi per scaricare i dati');
                return gatewaySessionLogin(token);
            })
            .then(function () { _gatewaySessionOk = true; });
    }

    function startExport(format) {
        if (!exportPrereqsOk()) return;
        var slug = String(_currentViewSlug || '').trim();
        var y = String(readYearParam() || '').trim();
        var cpv = String(cpvSelect.value || '').trim();
        var fmt = String(format || '').trim().toLowerCase();
        if (fmt !== 'json' && fmt !== 'xlsx') fmt = 'json';
        var url = apiBase() + '/osservatorio/export/region/' + encodeURIComponent(slug) +
            '?year=' + encodeURIComponent(y) +
            '&cpv=' + encodeURIComponent(cpv) +
            '&format=' + encodeURIComponent(fmt);
        if (fmt === 'json') {
            // Force download instead of navigating (browsers tend to render JSON).
            var filename = 'osservatorio_' + slug + '_' + y + '_' + cpv + '.json';
            fetch(url, { method: 'GET', credentials: 'include' })
                .then(function (r) {
                    if (!r.ok) return r.text().then(function (t) { throw new Error(t || ('HTTP ' + r.status)); });
                    return r.blob();
                })
                .then(function (blob) {
                    var a = document.createElement('a');
                    var objUrl = URL.createObjectURL(blob);
                    a.href = objUrl;
                    a.download = filename;
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                    setTimeout(function () { try { URL.revokeObjectURL(objUrl); } catch (e) {} }, 1500);
                    showLeadMagnet();
                    vgTrackOsservatorio('download_json', { slug: slug, cpv: cpv });
                })
                .catch(function () {
                    // Fallback: if something blocks fetch/download, navigate.
                    window.location.href = url;
                });
            return;
        }
        window.location.href = url;
        showLeadMagnet();
        vgTrackOsservatorio('download_xlsx', { slug: slug, cpv: cpv });
    }

    var map = null;
    var mapLoaded = false;
    var sourceId = 'vg-oss-pins';
    var layerId = 'vg-oss-pins-layer';
    var regionDimSourceId = 'vg-oss-region-dim';
    var regionDimLayerId = 'vg-oss-region-dim-layer';
    var regionLineSourceId = 'vg-oss-region-line';
    var regionLineLayerId = 'vg-oss-region-line-layer';
    var _maplibrePromise = null;
    var _territoryIcons = null;
    var _viewsByNuts = {};
    var _currentViewSlug = 'italia';
    var _cpvSeen = {};

    /** World box around Italy + margin; ring 0 of dim polygon (hole = region). */
    var _OSS_DIM_OUTER = [[-12, 32], [27, 32], [27, 49.5], [-12, 49.5], [-12, 32]];

    function extractRegionGeometry(regionGj) {
        if (!regionGj) return null;
        if (regionGj.type === 'Feature') return extractRegionGeometry(regionGj.geometry);
        if (regionGj.type === 'FeatureCollection' && regionGj.features && regionGj.features.length) {
            return extractRegionGeometry(regionGj.features[0].geometry);
        }
        if (regionGj.type === 'Polygon' || regionGj.type === 'MultiPolygon') return regionGj;
        return null;
    }

    function buildDimFeature(regionGeom) {
        var coords = [_OSS_DIM_OUTER.slice()];
        if (regionGeom.type === 'Polygon') {
            coords.push(regionGeom.coordinates[0]);
        } else if (regionGeom.type === 'MultiPolygon') {
            for (var i = 0; i < regionGeom.coordinates.length; i++) {
                coords.push(regionGeom.coordinates[i][0]);
            }
        }
        return { type: 'Feature', properties: {}, geometry: { type: 'Polygon', coordinates: coords } };
    }

    function buildOutlineFeatureCollection(regionGeom) {
        var feats = [];
        function addPolyRings(polyCoords) {
            for (var r = 0; r < polyCoords.length; r++) {
                feats.push({
                    type: 'Feature',
                    properties: {},
                    geometry: { type: 'LineString', coordinates: polyCoords[r] }
                });
            }
        }
        if (regionGeom.type === 'Polygon') {
            addPolyRings(regionGeom.coordinates);
        } else if (regionGeom.type === 'MultiPolygon') {
            for (var i = 0; i < regionGeom.coordinates.length; i++) {
                addPolyRings(regionGeom.coordinates[i]);
            }
        }
        return { type: 'FeatureCollection', features: feats };
    }

    function removeRegionHighlight(m) {
        if (!m || typeof m.getLayer !== 'function') return;
        try {
            if (m.getLayer(regionLineLayerId)) m.removeLayer(regionLineLayerId);
            if (m.getLayer(regionDimLayerId)) m.removeLayer(regionDimLayerId);
            if (m.getSource(regionLineSourceId)) m.removeSource(regionLineSourceId);
            if (m.getSource(regionDimSourceId)) m.removeSource(regionDimSourceId);
        } catch (e) {}
    }

    /**
     * Vista regione: velatura scura fuori confine + contorni (focus). La geometria viene dall’API (geojson NUTS).
     */
    function renderRegionHighlight(mapData, viewMeta) {
        var m = ensureMap();
        if (!m) return;
        var livello = viewMeta && viewMeta.livello;
        var run = function () {
            removeRegionHighlight(m);
            if (livello !== 'regione') {
                if (root) root.classList.remove('vg-osservatorio-root--region-focus');
                return;
            }
            var raw = mapData && mapData.region_geojson;
            var geom = extractRegionGeometry(raw);
            if (!geom) {
                if (root) root.classList.remove('vg-osservatorio-root--region-focus');
                return;
            }
            if (root) root.classList.add('vg-osservatorio-root--region-focus');
            var dimFeat = buildDimFeature(geom);
            var linesFc = buildOutlineFeatureCollection(geom);
            var beforePins = m.getLayer(layerId) ? layerId : undefined;
            try {
                m.addSource(regionDimSourceId, { type: 'geojson', data: dimFeat });
                m.addLayer(
                    {
                        id: regionDimLayerId,
                        type: 'fill',
                        source: regionDimSourceId,
                        paint: {
                            'fill-color': '#0b1220',
                            'fill-opacity': 0.5
                        }
                    },
                    beforePins
                );
                m.addSource(regionLineSourceId, { type: 'geojson', data: linesFc });
                m.addLayer(
                    {
                        id: regionLineLayerId,
                        type: 'line',
                        source: regionLineSourceId,
                        paint: {
                            'line-color': '#f8fafc',
                            'line-width': 2.2,
                            'line-opacity': 0.92,
                            'line-blur': 0.35
                        }
                    },
                    beforePins
                );
            } catch (e) {}
        };
        if (typeof m.loaded === 'function' && m.loaded()) run();
        else m.once('load', run);
    }

    function _loadCssOnce(href) {
        try {
            var links = document.querySelectorAll('link[rel="stylesheet"]');
            for (var i = 0; i < links.length; i++) {
                var h = links[i].getAttribute('href') || '';
                if (h === href) return;
            }
            var l = document.createElement('link');
            l.rel = 'stylesheet';
            l.href = href;
            l.crossOrigin = '';
            document.head.appendChild(l);
        } catch (e) {}
    }

    function _loadScriptOnce(src) {
        return new Promise(function (resolve, reject) {
            try {
                var scripts = document.querySelectorAll('script[src]');
                for (var i = 0; i < scripts.length; i++) {
                    var s0 = scripts[i].getAttribute('src') || '';
                    if (s0 === src) {
                        resolve(true);
                        return;
                    }
                }
                var s = document.createElement('script');
                s.src = src;
                s.async = true;
                s.crossOrigin = '';
                s.onload = function () { resolve(true); };
                s.onerror = function () { reject(new Error('MapLibre load failed')); };
                document.head.appendChild(s);
            } catch (e) {
                reject(e);
            }
        });
    }

    function ensureMapLibreLoaded() {
        if (window.maplibregl) return Promise.resolve(true);
        if (_maplibrePromise) return _maplibrePromise;
        var cssHref = 'https://unpkg.com/maplibre-gl@4.6.0/dist/maplibre-gl.css';
        var jsSrc = 'https://unpkg.com/maplibre-gl@4.6.0/dist/maplibre-gl.js';
        _maplibrePromise = Promise.resolve()
            .then(function () {
                _loadCssOnce(cssHref);
                return _loadScriptOnce(jsSrc);
            })
            .then(function () { return !!window.maplibregl; })
            .catch(function () { return false; });
        return _maplibrePromise;
    }

    function buildBaseStyle() {
        return {
            version: 8,
            sources: {
                osm: {
                    type: 'raster',
                    tiles: ['https://tile.openstreetmap.org/{z}/{x}/{y}.png'],
                    tileSize: 256,
                    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                }
            },
            layers: [{ id: 'osm-tiles', type: 'raster', source: 'osm', minzoom: 0, maxzoom: 19 }]
        };
    }

    function europeBoundsLngLat() {
        return [[-25.0, 30.0], [45.0, 72.0]];
    }

    function expandBounds(bounds, factor) {
        factor = Number(factor || 1);
        if (!bounds || bounds.length !== 2 || factor <= 0) return bounds;
        var sw = bounds[0], ne = bounds[1];
        var w = Number(sw[0]), s = Number(sw[1]), e = Number(ne[0]), n = Number(ne[1]);
        if (!isFinite(w) || !isFinite(s) || !isFinite(e) || !isFinite(n)) return bounds;
        var cx = (w + e) / 2;
        var cy = (s + n) / 2;
        var hw = ((e - w) / 2) * factor;
        var hh = ((n - s) / 2) * factor;
        return [[cx - hw, cy - hh], [cx + hw, cy + hh]];
    }

    function clampMapToEurope(m) {
        if (!m) return;
        var EU = europeBoundsLngLat();
        try { if (m.setMaxBounds) m.setMaxBounds(EU); } catch (eB) {}
        try {
            if (m.cameraForBounds && m.setMinZoom) {
                var cam = m.cameraForBounds(EU, { padding: 24 });
                if (cam && isFinite(cam.zoom)) m.setMinZoom(Math.max(0, cam.zoom - 0.25));
            }
        } catch (eZ) {}
    }

    function ensureMap() {
        if (map) return map;
        var el = document.getElementById('vg-oss-map');
        if (!el) return null;
        if (!window.maplibregl) return null;
        map = new window.maplibregl.Map({
            container: el,
            style: buildBaseStyle(),
            center: [12.5, 42.5],
            zoom: 5.7
        });
        map.addControl(new window.maplibregl.NavigationControl(), 'top-right');
        map.on('load', function () {
            mapLoaded = true;
            clampMapToEurope(map);
        });
        window.addEventListener('resize', function () {
            try { clampMapToEurope(map); } catch (eR) {}
        }, { passive: true });
        return map;
    }

    function pinsToGeojson(pins) {
        var feats = [];
        for (var i = 0; i < (pins || []).length; i++) {
            var p = pins[i] || {};
            var lat = parseFloat(p.lat);
            var lon = parseFloat(p.lon);
            if (!isFinite(lat) || !isFinite(lon)) continue;
            feats.push({
                type: 'Feature',
                geometry: { type: 'Point', coordinates: [lon, lat] },
                properties: {
                    title: String(p.title || ''),
                    amount: Number(p.amount || 0),
                    count: Number(p.count || 0)
                }
            });
        }
        return { type: 'FeatureCollection', features: feats };
    }

    function colorForAmount(a) {
        if (!isFinite(a)) return '#f59e0b';
        if (a >= 50_000_000) return '#dc2626';
        if (a >= 10_000_000) return '#f97316';
        if (a >= 2_000_000) return '#f59e0b';
        if (a >= 500_000) return '#84cc16';
        return '#22c55e';
    }

    function renderMapPins(pins) {
        var m = ensureMap();
        if (!m) {
            // Best effort: try dynamic loading once, then re-render.
            ensureMapLibreLoaded().then(function (ok) {
                if (!ok) {
                    setStatus('MapLibre non disponibile');
                    return;
                }
                try {
                    renderMapPins(pins);
                } catch (e) {}
            });
            return;
        }
        var data = pinsToGeojson(pins);
        function apply() {
            if (!mapLoaded) return;
            if (m.getSource(sourceId)) {
                m.getSource(sourceId).setData(data);
                return;
            }
            m.addSource(sourceId, { type: 'geojson', data: data });
            m.addLayer({
                id: layerId,
                type: 'circle',
                source: sourceId,
                paint: {
                    'circle-radius': ['interpolate', ['linear'], ['zoom'], 4, 3, 6, 5, 9, 9],
                    'circle-color': [
                        'case',
                        ['>', ['get', 'amount'], 50000000], '#dc2626',
                        ['>', ['get', 'amount'], 10000000], '#f97316',
                        ['>', ['get', 'amount'], 2000000], '#f59e0b',
                        ['>', ['get', 'amount'], 500000], '#84cc16',
                        '#22c55e'
                    ],
                    'circle-stroke-width': 1,
                    'circle-stroke-color': 'rgba(0,0,0,0.25)'
                }
            });
            m.on('click', layerId, function (e) {
                try {
                    var f = e.features && e.features[0];
                    if (!f) return;
                    var props = f.properties || {};
                    var html =
                        '<div class="vg-oss-popup">' +
                        '<div class="vg-oss-popup__title">' + String(props.title || '') + '</div>' +
                        '<div class="vg-oss-popup__meta">Importo: ' + fmtEuro(Number(props.amount || 0)) + '</div>' +
                        '<div class="vg-oss-popup__meta">N. aggiudicazioni: ' + fmtInt(Number(props.count || 0)) + '</div>' +
                        '</div>';
                    new window.maplibregl.Popup({ closeButton: true, maxWidth: '280px' })
                        .setLngLat(e.lngLat)
                        .setHTML(html)
                        .addTo(m);
                } catch (ex) {}
            });
            m.on('mouseenter', layerId, function () { m.getCanvas().style.cursor = 'pointer'; });
            m.on('mouseleave', layerId, function () { m.getCanvas().style.cursor = ''; });
        }
        if (mapLoaded) apply();
        else m.once('load', apply);
    }

    /**
     * Regione: zoom sulla bbox dall’API (fit_bounds). Italia: inquadra tutto il paese.
     */
    function applyMapCamera(mapData, viewMeta) {
        var m = ensureMap();
        if (!m) return;
        var livello = viewMeta && viewMeta.livello;
        var fb = mapData && mapData.fit_bounds;
        var center = mapData && mapData.center;
        var zoom = mapData && mapData.zoom;
        var doCam = function () {
            try {
                if (livello === 'comune' && center && Array.isArray(center) && center.length >= 2) {
                    m.jumpTo({
                        center: [Number(center[0]), Number(center[1])],
                        zoom: Number(zoom || 12.5),
                        duration: 450
                    });
                } else if (
                    (livello === 'provincia' || livello === 'comune' || livello === 'regione') &&
                    fb &&
                    Array.isArray(fb) &&
                    fb.length === 2 &&
                    Array.isArray(fb[0]) &&
                    Array.isArray(fb[1]) &&
                    fb[0].length >= 2 &&
                    fb[1].length >= 2
                ) {
                    var maxZ = livello === 'comune' ? 13 : (livello === 'provincia' ? 10 : 11);
                    m.fitBounds(fb, { padding: livello === 'provincia' ? 32 : 56, maxZoom: maxZ, duration: 450 });
                } else if (livello === 'provincia' || livello === 'comune') {
                    return;
                } else {
                    m.jumpTo({ center: [12.5, 42.5], zoom: 5.7, duration: 0 });
                }
            } catch (e) {}
        };
        if (typeof m.loaded === 'function' && m.loaded()) doCam();
        else m.once('load', doCam);
    }

    function renderKpis(kpi) {
        var wrap = qs('[data-oss-kpis]', root);
        if (!wrap) return;
        kpi = kpi || {};
        wrap.innerHTML =
            '<div class="vg-oss-kpi"><div class="vg-oss-kpi__label">Importo totale</div><div class="vg-oss-kpi__value">' + fmtEuro(Number(kpi.importo_totale || 0)) + '</div></div>' +
            '<div class="vg-oss-kpi"><div class="vg-oss-kpi__label">Numero bandi</div><div class="vg-oss-kpi__value">' + fmtInt(Number(kpi.numero_bandi || 0)) + '</div></div>' +
            '<div class="vg-oss-kpi"><div class="vg-oss-kpi__label">Importo medio bando</div><div class="vg-oss-kpi__value">' + fmtEuro(Number(kpi.importo_medio || 0)) + '</div></div>' +
            '<div class="vg-oss-kpi"><div class="vg-oss-kpi__label">€/abitante</div><div class="vg-oss-kpi__value">' + (kpi.euro_per_abitante != null ? fmtEuro(Number(kpi.euro_per_abitante || 0)) : '—') + '</div></div>';
    }

    function esc(s) {
        return String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }

    function severityBadge(sev) {
        var s = String(sev || '').toLowerCase();
        var cls = s === 'alta' ? 'is-high' : s === 'media' ? 'is-med' : 'is-low';
        var lab = s ? s.toUpperCase() : '—';
        return '<span class="vg-oss-sev ' + cls + '">' + esc(lab) + '</span>';
    }

    function iconSvgForAnomaly(a) {
        var icons = _territoryIcons || {};
        var liv = String((a && a.livello) || '').toLowerCase();
        if (liv === 'nazione') return String(icons.italia || '');
        if (liv === 'regione') {
            var nuts = String((a && a.codice_nuts) || '').trim();
            var reg = (icons.regions || {})[nuts];
            return reg ? String(reg) : '';
        }
        return '';
    }

    function regionSlugForAnomaly(a) {
        var liv = String((a && a.livello) || '').toLowerCase();
        if (liv !== 'regione') return '';
        var nuts = String((a && a.codice_nuts) || '').trim();
        return String((_viewsByNuts && _viewsByNuts[nuts]) || '');
    }

    function territoryLine(a) {
        a = a || {};
        var t = String(a.territorio_nome || '').trim();
        if (!t) t = String(a.codice_nuts || '').trim();
        var liv = String(a.livello || '').trim();
        if (!t) return '';
        // Render only when it adds information (e.g. in Italia view where anomalies may be regional).
        return '<div class="vg-oss-card__meta">Territorio: <strong>' + esc(t) + '</strong>' + (liv ? (' <span class="vg-oss-card__pill">' + esc(liv) + '</span>') : '') + '</div>';
    }

    function anomalyDetailLine(a) {
        a = a || {};
        var facts = a.payload_json || a.payload || {};
        if (!facts || typeof facts !== 'object') facts = {};

        function fmtPct(x) {
            var n = (typeof x === 'number') ? x : parseFloat(String(x || ''));
            if (!isFinite(n)) return '';
            var sign = n > 0 ? '+' : '';
            return sign + n.toFixed(0) + '%';
        }

        // Prefer explicit percent fields, if present.
        var sc = facts.scostamento_pct;
        var q = facts.quota_top3_pct;
        if (sc != null && isFinite(Number(sc))) {
            return '<div class="vg-oss-card__meta">Scostamento: <strong>' + esc(fmtPct(sc)) + '</strong> (€/abitante vs Italia)</div>';
        }
        if (q != null && isFinite(Number(q))) {
            return '<div class="vg-oss-card__meta">Quota top 3: <strong>' + esc(fmtPct(q)) + '</strong></div>';
        }
        // Fallback: ratio can be shown if nothing else is available.
        var ratio = facts.ratio;
        var rr = (typeof ratio === 'number') ? ratio : parseFloat(String(ratio || ''));
        if (isFinite(rr) && rr > 0) {
            return '<div class="vg-oss-card__meta">Rapporto: <strong>' + esc(rr.toFixed(2) + '×') + '</strong> (vs Italia)</div>';
        }
        return '';
    }

    function normalizedMetricsLine(a) {
        a = a || {};
        var nm = a.normalized_metrics || (a.payload_json || {}).normalized_metrics || null;
        if (!nm || typeof nm !== 'object') return '';
        var eur = nm.eur_per_target;
        var y = nm.target_year_used;
        var tt = String(nm.target_type || '').trim();
        var n = (typeof eur === 'number') ? eur : parseFloat(String(eur || ''));
        if (!isFinite(n) || n <= 0) return '';
        var label = '€/target';
        if (tt === 'transport') label = '€/km autostrade';
        else if (tt === 'patients') label = '€/posto letto';
        else if (tt === 'waste') label = '€/ton rifiuti (da kg/ab)';
        var ytxt = (y && String(y).trim()) ? (' — anno ' + esc(String(y).trim())) : '';
        return '<div class="vg-oss-card__meta">Normalizzazione: <strong>' + esc(n.toFixed(2)) + '</strong> ' + esc(label) + ytxt + '</div>';
    }

    function anomalyClassBadge(a) {
        a = a || {};
        var facts = a.payload_json || a.payload || {};
        if (!facts || typeof facts !== 'object') facts = {};
        var t = String(a.anomaly_type || facts.anomaly_type || '').trim().toLowerCase();
        if (!t) return '';
        var icon = '';
        var label = '';
        if (t === 'whale') { icon = '🐋'; label = 'whale'; }
        else if (t === 'system') { icon = '🏛️'; label = 'system'; }
        else if (t === 'diffuse') { icon = '🌊'; label = 'diffuse'; }
        else { icon = '•'; label = t; }
        var conc = (a.concentration && typeof a.concentration === 'object') ? a.concentration : (facts.concentration || {});
        var top1 = conc && conc.top_1_pct != null ? (Number(conc.top_1_pct) * 100.0) : NaN;
        var top3 = conc && conc.top_3_pct != null ? (Number(conc.top_3_pct) * 100.0) : NaN;
        var title = 'Classe: ' + label;
        if (Number.isFinite(top1)) title += ' | top 1 buyer: ' + top1.toFixed(0) + '%';
        if (Number.isFinite(top3)) title += ' | top 3 buyer: ' + top3.toFixed(0) + '%';
        return '<span class="vg-oss-card__class" title="' + esc(title) + '" aria-label="' + esc(title) + '">' + esc(icon) + '</span>';
    }

    function renderAnomalies(items) {
        var grid = qs('[data-oss-anomalies-grid]', root);
        if (!grid) return;
        items = Array.isArray(items) ? items : [];
        if (!items.length) {
            grid.innerHTML = '<div class="vg-oss-empty">Nessuna anomalia rilevata per i filtri selezionati.</div>';
            return;
        }
        function renderCard(a) {
            a = a || {};
            var iconSvg = iconSvgForAnomaly(a);
            var regionSlug = regionSlugForAnomaly(a);
            var iconWrap = '';
            if (iconSvg) {
                if (_currentViewSlug === 'italia' && regionSlug) {
                    var y = readYearParam();
                    var cpv = String(a.cpv_prefix || '').trim();
                    var qs0 = '';
                    if (y) qs0 += (qs0 ? '&' : '?') + 'year=' + encodeURIComponent(y);
                    if (cpv) qs0 += (qs0 ? '&' : '?') + 'cpv=' + encodeURIComponent(cpv);
                    iconWrap =
                        '<a class="vg-oss-card__iconlink" href="/osservatorio/regione/' + encodeURIComponent(regionSlug) + '/' + qs0 + '" ' +
                        'title="Apri vista regione" aria-label="Apri vista regione">' +
                        '<span class="vg-oss-card__icon" aria-hidden="true">' + iconSvg + '</span>' +
                        '</a>';
                } else {
                    iconWrap = '<span class="vg-oss-card__icon" aria-hidden="true">' + iconSvg + '</span>';
                }
            }
            return (
                '<article class="vg-oss-card">' +
                '<div class="vg-oss-card__top">' +
                '<div class="vg-oss-card__titlewrap">' +
                iconWrap +
                anomalyClassBadge(a) +
                '<div class="vg-oss-card__title">' + esc(a.title || '') + '</div>' +
                '</div>' +
                severityBadge(a.severity) +
                '</div>' +
                '<div class="vg-oss-card__meta">CPV: <strong>' + esc(a.cpv_prefix || '') + '</strong>' + (a.cpv_label ? (' — ' + esc(a.cpv_label)) : '') + '</div>' +
                anomalyDetailLine(a) +
                normalizedMetricsLine(a) +
                territoryLine(a) +
                '<div class="vg-oss-card__body">' + esc(a.ai_text || a.summary || '') + '</div>' +
                '</article>'
            );
        }

        // Italia view: group by region so you see *all* anomalies per region.
        if (_currentViewSlug === 'italia') {
            var by = {};
            var order = [];
            for (var i = 0; i < items.length; i++) {
                var a = items[i] || {};
                var key = String(a.codice_nuts || a.territorio_nome || '—').trim() || '—';
                if (!by[key]) {
                    by[key] = { label: String(a.territorio_nome || a.codice_nuts || key || '—'), items: [] };
                    order.push(key);
                }
                by[key].items.push(a);
            }
            // Keep the group order as received from the API.
            // Backend is the source of truth for North→South ordering.
            var html = '';
            for (var g = 0; g < order.length; g++) {
                var k = order[g];
                var grp = by[k];
                if (!grp || !grp.items || !grp.items.length) continue;
                html += '<h3 class="vg-oss-region-title">' + esc(grp.label || k) + '</h3>';
                for (var j = 0; j < grp.items.length; j++) {
                    html += renderCard(grp.items[j]);
                }
            }
            grid.innerHTML = html;
            return;
        }

        // Region view: keep flat list.
        var out = '';
        for (var ii = 0; ii < items.length; ii++) out += renderCard(items[ii] || {});
        grid.innerHTML = out;
    }

    function renderDisclaimer(text) {
        var el = qs('[data-oss-disclaimer]', root);
        if (!el) return;
        el.innerHTML =
            '<h2 class="vg-osservatorio-section-title">Disclaimer</h2>' +
            '<p class="vg-oss-disclaimer__text">' + esc(text || '') + '</p>';
    }

    async function loadViewsIntoSelector() {
        var data = await apiJson('/osservatorio/views');
        var views = data.views || [];
        _viewsByNuts = {};
        if (!viewSelect) return data;
        viewSelect.innerHTML = '';
        for (var i = 0; i < views.length; i++) {
            var v = views[i] || {};
            var nuts = String(v.nuts || '').trim();
            var s = String(v.slug || '').trim();
            if (nuts && s) _viewsByNuts[nuts] = s;
            var opt = document.createElement('option');
            opt.value = String(v.slug || '');
            opt.textContent = String(v.label || v.slug || '');
            viewSelect.appendChild(opt);
        }
        return data;
    }

    function fillCpvSelector(anomalies) {
        // v1: derive CPV prefixes from anomalies list
        var current = '';
        try { current = String(cpvSelect.value || '').trim(); } catch (e0) { current = ''; }
        // If current is empty but URL has a cpv param, prefer it.
        if (!current) {
            try { current = String(readCpvParam() || '').trim(); } catch (eP) { current = ''; }
        }
        var opts = ['<option value="">Tutti i settori CPV</option>'];
        // Sticky union: avoid options disappearing when the user filters by a CPV.
        for (var i = 0; i < (anomalies || []).length; i++) {
            var a = anomalies[i] || {};
            var p = String(a.cpv_prefix || '').trim();
            if (!p) continue;
            _cpvSeen[p] = _cpvSeen[p] || { p: p, label: String(a.cpv_label || '').trim() };
            if (!_cpvSeen[p].label) _cpvSeen[p].label = String(a.cpv_label || '').trim();
        }
        var keys = Object.keys(_cpvSeen || {});
        keys.sort(function (a, b) {
            var na = parseInt(a, 10), nb = parseInt(b, 10);
            if (isFinite(na) && isFinite(nb) && na !== nb) return na - nb;
            if (a < b) return -1;
            if (a > b) return 1;
            return 0;
        });
        for (var k = 0; k < keys.length; k++) {
            var key = keys[k];
            var row = _cpvSeen[key] || {};
            var p2 = String(row.p || key || '').trim();
            if (!p2) continue;
            var lab = String(row.label || '').trim();
            opts.push('<option value="' + esc(p2) + '">' + esc(p2 + (lab ? (' — ' + lab) : '')) + '</option>');
        }
        cpvSelect.innerHTML = opts.join('');
        // Preserve current selection if possible (avoid resetting to "Tutti i CPV" after reload).
        try {
            if (current && !_cpvSeen[current]) {
                // Keep user selection visible even if not in derived list (e.g. filtered results).
                cpvSelect.insertAdjacentHTML('beforeend', '<option value="' + esc(current) + '">' + esc(current) + '</option>');
            }
            cpvSelect.value = current;
        } catch (e1) {}
    }

    async function applyGeoPayload(data) {
        var period = data.period || {};
        if (periodEl) {
            var pf = String(period.from || '');
            var pt = String(period.to || '');
            var label = String(period.label || '');
            if (label && label.indexOf('year:') === 0) {
                periodEl.textContent = 'Anno ' + label.replace('year:', '');
            } else if (pf && pt) {
                periodEl.textContent = pf + ' → ' + pt;
            }
        }

        var view = data.view || {};
        var mapTitle = qs('[data-oss-map-title]', root);
        if (mapTitle && view.label) mapTitle.textContent = 'Mappa — ' + String(view.label);

        renderKpis(data.kpi || {});
        var mapBlock = data.map || {};
        await ensureMapLibreLoaded().catch(function () {});
        renderMapPins(mapBlock.pins || []);
        renderRegionHighlight(mapBlock, view);
        applyMapCamera(mapBlock, view);
        // Se la mappa era già caricata, ripeti il posizionamento dopo i pin.
        var m = ensureMap();
        if (m && mapBlock.fit_bounds) {
            m.once('idle', function () {
                applyMapCamera(mapBlock, view);
            });
        }
        renderDisclaimer(data.disclaimer || '');
        return data;
    }

    async function loadGeoView(kind, slug, cpv) {
        setStatus('Caricamento…');
        var init = readInitialGeoPayload();
        var path = '/osservatorio/geo-view/' + encodeURIComponent(kind || '') + '/' + encodeURIComponent(slug || '');
        var y = readYearParam();
        if (y) path += '?year=' + encodeURIComponent(y);
        if (cpv) path += (path.indexOf('?') !== -1 ? '&' : '?') + 'cpv=' + encodeURIComponent(String(cpv));
        var data = null;
        try {
            data = await apiJson(path);
        } catch (e) {
            if (init) data = init;
            else throw e;
        }
        setStatus('');
        return applyGeoPayload(data);
    }

    async function loadView(slug, cpv) {
        setStatus('Caricamento…');
        var path = '/osservatorio/view/' + encodeURIComponent(slug || 'italia');
        var y = readYearParam();
        if (y) path += '?year=' + encodeURIComponent(y);
        if (cpv) path += (path.indexOf('?') !== -1 ? '&' : '?') + 'cpv=' + encodeURIComponent(String(cpv));
        var data = await apiJson(path);
        setStatus('');

        var period = data.period || {};
        if (periodEl) {
            var pf = String(period.from || '');
            var pt = String(period.to || '');
            var label = String(period.label || '');
            if (label && label.indexOf('year:') === 0) {
                periodEl.textContent = 'Anno ' + label.replace('year:', '');
            } else if (pf && pt) {
                periodEl.textContent = pf + ' → ' + pt;
            } else {
                periodEl.textContent = 'Periodo';
            }
        }

        var view = data.view || {};
        _currentViewSlug = String(view.slug || slug || 'italia');
        if (backLink) {
            backLink.hidden = (view.slug === 'italia');
        }
        renderExportState();

        renderKpis(data.kpi || {});
        var mapBlock = data.map || {};
        await ensureMapLibreLoaded().catch(function () {});
        await loadTerritoryIcons().catch(function () {});
        renderMapPins(mapBlock.pins || []);
        renderRegionHighlight(mapBlock, view);
        applyMapCamera(mapBlock, view);
        renderAnomalies(data.anomalies || []);
        renderDisclaimer(data.disclaimer || '');

        fillCpvSelector(data.anomalies || []);
        renderExportState();
        applyViewSeo(data);
        renderProvinceLinks(data.province_links || []);
        var insights = data.insights || [];
        if (insights.length) {
            var ins = qs('[data-oss-insight]', root);
            var insT = qs('[data-oss-insight-text]', root);
            if (ins && insT) {
                ins.hidden = false;
                insT.textContent = insights.join('\n\n');
            }
        }
        return data;
    }

    async function boot() {
        try {
            // MapLibre may be blocked by CSP/filters; load dynamically so the page still works.
            ensureMapLibreLoaded().then(function (ok) {
                if (!ok) setStatus('MapLibre non disponibile');
            });
            var slug = currentSlugFromPath();
            var cpv0 = readCpvParam();
            renderCtaFromMember();
            loadWeeklyStat().catch(function () {});
            if (slug === 'italia' && !isGeoPage()) {
                loadNationalSummary().catch(function () {});
            }
            await loadViewsIntoSelector();
            if (viewSelect) viewSelect.value = slug;
            if (backLink) backLink.addEventListener('click', function (e) {
                e.preventDefault();
                pushSlug('italia');
            });
            if (viewSelect && !isGeoPage()) viewSelect.addEventListener('change', function () {
                pushSlug(viewSelect.value || 'italia');
            });

            // initial load
            try {
                if (cpvSelect) {
                    var v0 = String(cpv0 || '').trim();
                    if (v0) {
                        // Ensure value exists as an <option> before assigning, otherwise the browser resets it to "".
                        var exists = false;
                        for (var oi = 0; oi < cpvSelect.options.length; oi++) {
                            if (String(cpvSelect.options[oi].value || '').trim() === v0) { exists = true; break; }
                        }
                        if (!exists) {
                            cpvSelect.insertAdjacentHTML('beforeend', '<option value="' + esc(v0) + '">' + esc(v0) + '</option>');
                        }
                    }
                    cpvSelect.value = v0;
                }
            } catch (eC) {}
            var geo = currentGeoFromPath();
            if (geo) {
                await loadGeoView(geo.kind, geo.slug, String(cpv0 || ''));
            } else {
                await loadView(slug, String(cpv0 || ''));
            }

            if (cpvSelect) cpvSelect.addEventListener('change', function () {
                var geoNow = currentGeoFromPath();
                var loader = geoNow
                    ? loadGeoView(geoNow.kind, geoNow.slug, cpvSelect.value || '')
                    : loadView((viewSelect && viewSelect.value) || slug, cpvSelect.value || '');
                loader.catch(function (e) {
                    setStatus(e && e.message ? e.message : 'Errore');
                });
            });

            // Export UI wiring
            if (exportToggle && exportMenu && exportWrap) {
                exportToggle.addEventListener('click', function (e) {
                    e.preventDefault();
                    if (exportToggle.disabled) return;
                    if (exportMenu.hidden) openExportMenu();
                    else closeExportMenu();
                });
                document.addEventListener('click', function (e) {
                    if (!exportWrap.contains(e.target)) closeExportMenu();
                }, { passive: true });
                exportMenu.addEventListener('click', function (e) {
                    var t = e.target;
                    var fmt = (t && t.getAttribute) ? t.getAttribute('data-oss-export-format') : '';
                    if (!fmt) return;
                    e.preventDefault();
                    closeExportMenu();
                    if (!exportPrereqsOk()) return;
                    if (!isMemberFromDom()) {
                        openDialog();
                        return;
                    }
                    ensureGatewaySession()
                        .then(function () { startExport(fmt); })
                        .catch(function () { openDialog(); });
                });
            }
            if (dialogBackdrop) dialogBackdrop.addEventListener('click', function () { closeDialog(); });
            if (dialogClose) dialogClose.addEventListener('click', function (e) { e.preventDefault(); closeDialog(); });
            var saveBtn = qs('[data-oss-save-search]', root);
            if (saveBtn) {
                saveBtn.hidden = false;
                saveBtn.addEventListener('click', function (e) {
                    e.preventDefault();
                    saveCurrentSearch().catch(function (err) {
                        setStatus(err && err.message ? err.message : 'Errore salvataggio');
                    });
                });
            }
            document.querySelectorAll('[data-oss-cta-primary], [data-oss-cta-secondary]').forEach(function (a) {
                a.addEventListener('click', function () {
                    vgTrackOsservatorio('cta_click', { href: a.getAttribute('href') || '' });
                });
            });
        } catch (e) {
            setStatus((e && e.message) ? e.message : 'Errore');
        }
    }

    boot();
})(window, document);

